import { useAtom } from 'jotai';
import { modalAtom, toastAlertAtom, detailSidebarAtom } from '~/atoms/pageActions';
export const usePageActions = () => {
    const [modal, setModal] = useAtom(modalAtom);
    const [toastAlert, setToastAlert] = useAtom(toastAlertAtom);
    const [detailSidebar, setDetailSidebar] = useAtom(detailSidebarAtom);
    const setModalOpen = (isOpen) => {
        if (!isOpen) {
            setModal({ isOpen: false, config: undefined });
        }
    };
    return {
        modalOpen: modal.isOpen,
        modalConfig: modal.config,
        setModalOpen,
        toastAlert,
        setToastAlert,
        detailSidebarOpen: detailSidebar.isOpen,
        detailSidebarEntity: detailSidebar.entity,
        detailSidebarEntityType: detailSidebar.entityType,
        detailSidebar,
        setDetailSidebar
    };
};
